import { useTheme } from 'styled-components'
import styled from 'styled-components'
import { ReactComponent as SearchFilterIcon } from 'icons/filterIcon.svg'
import { Button } from 'common/atoms/Button/Button'

const StyledSearchFilterIcon = styled(SearchFilterIcon)`
  && {
    transform: scale(0.75);
    margin-right: 1em;
    fill: ${props => props.theme.colors.accent1};
  }
`

interface IFilterButton {
  onClick?: Function
}

const FilterButton = ({ onClick }: IFilterButton) => {
  const theme = useTheme()

  return (
    <Button
      design='secondary'
      small
      onClick={() => {
        onClick?.()
      }}
      startIcon={<StyledSearchFilterIcon style={{ marginRight: '0em' }} />}
    >
      Filter
    </Button>
  )
}

export default FilterButton
